import $ from "jquery";
import "jquery-validation-unobtrusive";

// jquery-validation-unobtrusive extensions
// data-val-* (adapter), data-val-*-* (params)
// ex: data-val-requiredif-set="", data-val-requiredif-set=""

$.validator.unobtrusive.adapters.add("requiredif", ['set'], function (o) {
 
    o.rules['requiredif'] = o.params;

    if (o.message) {

        o.messages['requiredif'] = o.message;
    } 
});

$.validator.addMethod("requiredif", function (value, element, params) {
     
    // ',' = OR
    // - TODO AND 
    // - TODO refacto
    //
    var properties = params.set.split(',');
 
    if (element.value && element.value.length > 0) {
        return true;
    }
    for (var i in properties) {

        var p = properties[i].trim();

        for (var j in this.currentForm) {

            var current = this.currentForm[j];

            if (current == null) {
                continue;
            }

            if (current.id === p) {

                if ($(current).is('input[type="checkbox"]') || $(current).is('input[type="radio"]')) {

                    if ($(current).is(':checked')) {

                        return false;
                    }
                }
                else {

                    if (current.value && current.value.length > 0) {
                        
                        return false;
                    }
                }
            }
        }
    }

    return true;

}, '');
  
$.validator.unobtrusive.adapters.add("countryawarezipcodevalidation", ['propertycountryid'], function (o) {
    o.rules['countryawarezipcodevalidation'] = o.params;
    o.messages['countryawarezipcodevalidation'] = o.message;
    
});

$.validator.addMethod("countryawarezipcodevalidation", function (value, element, params) {

    if (value == "undefined" || value == "")
        return true;

    var selectedOption = $(element.form).find('select[name="' + params.propertycountryid + '"]').find("option:selected");

    var cellPhoneRegex = selectedOption.attr("data-zipcode-validation");

    var myRegex = new RegExp(cellPhoneRegex, 'gi');

    if (myRegex.test(value)) {
        return true;
    }
    return false;
}, '');
 
$.validator.unobtrusive.adapters.add("countryawarephonevalidation", ['propertycountryid'], function (o) {
    o.rules['countryawarephonevalidation'] = o.params;
    o.messages['countryawarephonevalidation'] = o.message;
});

$.validator.addMethod("countryawarephonevalidation", function (value, element, params) {
    if (value == "undefined" || value == "")
        return true;
    
    var selectedOption = $(element.form).find('select[name="' + params.propertycountryid + '"]').find("option:selected");

    var cellPhoneRegex = selectedOption.attr("data-phone-validation");

    var myRegex = new RegExp(cellPhoneRegex, 'gi');

    if (myRegex.test(value)) {
        return true;
    }

    return false;
}, '');
 
$.validator.unobtrusive.adapters.add("countryawaretaxnumbervalidation", ['propertycountryid'], function (o) {
    o.rules['countryawaretaxnumbervalidation'] = o.params;
    o.messages['countryawaretaxnumbervalidation'] = o.message;
});

$.validator.addMethod("countryawaretaxnumbervalidation", function (value, element, params) {
    if (value == "undefined" || value == "")
        return true;

    var selectedOption = $(element.form).find('select[name="' + params.propertycountryid + '"]').find("option:selected");

    var TaxNumberRegex = selectedOption.attr("data-taxnumber-validation");

    var myRegex = new RegExp(TaxNumberRegex, 'gi');

    if (myRegex.test(value)) {
        return true;
    }
    return false;
}, '');

$.validator.unobtrusive.adapters.add("must-be-true", function (options) {
 
    options.rules["must-be-true"] = options.params;

    if (options.message) {

        options.messages["must-be-true"] = options.message;
    } 
});

$.validator.addMethod("must-be-true", function (value, element, params) {
  
    if (!this.depend(params, element))
        return "dependency-mismatch";

    return element.checked;
});

$.validator.unobtrusive.adapters.add("requiredifnotset", ['propertythatcanbenotset'], function (o) {
  o.rules['requiredifnotset'] = o.params;
  o.messages['requiredifnotset'] = o.message;
});

$.validator.addMethod("requiredifnotset", function (value, element, params) {
  var otherValue = $(element.form).find('input[name="' + params.propertythatcanbenotset + '"]').val();

  if ((value != "undefined" && value != "")
    || (otherValue != "undefined" && otherValue != ""))
    return true;

  return false;
}, '');

$.validator.unobtrusive.adapters.add("requiredifequal", ['otherproperty', 'otherpropertyreferencevalue'], function(o) {
  o.rules['requiredifequal'] = o.params;
  o.messages['requiredifequal'] = o.message;
});

$.validator.addMethod("requiredifequal", function(value, element, params) {
  var otherPropertyValue = $(element.form).find('select[name="' + params.otherproperty + '"]').val();

  if (params.otherpropertyreferencevalue == otherPropertyValue) {
    if (value == "undefined" || value == "") {
      return false
    }
  }
  return true;
}, '');

$.validator.unobtrusive.adapters.add("countryawarecellphonevalidation", ['propertycountryid'], function(o) {
  o.rules['countryawarecellphonevalidation'] = o.params;
  o.messages['countryawarecellphonevalidation'] = o.message;
});

$.validator.addMethod("countryawarecellphonevalidation", function(value, element, params) {
  if (value == "undefined" || value == "")
    return true;

  var selectedOption = $(element.form).find('select[name="' + params.propertycountryid + '"]').find("option:selected");

  var cellPhoneRegex = selectedOption.attr("data-cellphone-validation");

  var myRegex = new RegExp(cellPhoneRegex, 'gi');

  if (myRegex.test(value)) {
    return true;
  }

  return false;
}, '');

$.validator.unobtrusive.adapters.add("countryawarehomephonevalidation", ['propertycountryid'], function(o) {
  o.rules['countryawarehomephonevalidation'] = o.params;
  o.messages['countryawarehomephonevalidation'] = o.message;
});

$.validator.addMethod("countryawarehomephonevalidation", function(value, element, params) {
  if (value == "undefined" || value == "")
    return true;

  var selectedOption = $(element.form).find('select[name="' + params.propertycountryid + '"]').find("option:selected");

  var cellPhoneRegex = selectedOption.attr("data-homephone-validation");

  var myRegex = new RegExp(cellPhoneRegex, 'gi');

  if (myRegex.test(value)) {
    return true;
  }

  return false;
}, '');

$.validator.unobtrusive.adapters.add("requiredifset", ['propertiesthatmustbeset'], function (o) {
  o.rules['requiredifset'] = o.params;
  o.messages['requiredifset'] = o.message;
});

$.validator.addMethod("requiredifset", function (value, element, params) { //value => tb
  var ischecked = $(element.form).find('input[id="' + params.propertiesthatmustbeset + '"]').is(":checked"); //checkbox

  if (ischecked == false)
  {
    return true;
  }
  else
  {
    if ((value != "undefined" && value != ""))
    {
      return true;
    }
  }

  return false;

}, '');
